<fhm-page [title]="'fhm.planUpdateBatchJob.title'" [showDone]="true"
          [showSave]="false"
          (doneClicked)="done()"
          [description]="'fhm.planUpdateBatchJob.description'">

    <fui-rows>
        <fui-row>
            <fui-two-columns>
                <fui-column>
                    <input #inputUploadFile style="display: none;" type="file" (click)="inputUploadClick($event)"
                           (change)="fileSelected($event)">
                    <fhm-provision-button [title]="'fhm.common.label.uploadFile'" (clicked)="uploadFileClick()"></fhm-provision-button>
                </fui-column>
            </fui-two-columns>
        </fui-row>
        <fui-row>
            <fui-columns>
                <fui-column>
                    <fhm-search-grid [records]="gridData"
                                     [columns]="['createdTime', 'fileName', 'status']"
                                     [showLink]="false"
                                     [showDownloadReport]="true"
                                     [showDelete]="false"
                                     [type]="'batch-job'"
                                     (downloadReport)="downloadReport($event)">
                    </fhm-search-grid>
                </fui-column>
            </fui-columns>
        </fui-row>
    </fui-rows>

</fhm-page>
